module.exports = __webpack_public_path__ + "img/product_service10.1523fb44.png";